import { getUser } from '../auth/user';
import { CreateOrderType } from '@fd/common/biz/order';
import Gleap from 'gleap';
import { honoPrivateClient } from '../api/honoClient';
import posthog from 'posthog-js';
import { usePaymentDetailsStore } from '../store/paymentDetailsStore';
import { initializePaddle } from '@paddle/paddle-js';
import { determineEnv } from '@fd/common/api/determineEnv';

export const createCheckout = async (orderParams: CreateOrderType) => {
  const user = await getUser();
  const { setCoupon } = usePaymentDetailsStore.getState();
  if (!user) return;

  const gclid = localStorage.getItem('gclid');
  const utm_source = localStorage.getItem('utm_source');
  const utm_campaign = localStorage.getItem('utm_campaign');
  const utm_medium = localStorage.getItem('utm_medium');

  if (gclid) orderParams.gclid = gclid;
  if (utm_source) orderParams.utm_source = utm_source;
  if (utm_campaign) orderParams.utm_campaign = utm_campaign;
  if (utm_medium) orderParams.utm_medium = utm_medium;
  orderParams.posthog_sid = posthog.get_session_id();

  const response = await honoPrivateClient.checkout.create.$post({
    json: {
      order: orderParams,
    },
  });

  Gleap.trackEvent('Checkout created', {
    userId: user.id,
    email: user.email,
    order: orderParams,
  });

  if (response.ok) {
    setCoupon(undefined);
    const data = await response.json();
    if ('url' in data) {
      window.location.href = data.url;
    } else {
      const { transactionId } = data;
      const paddle = await initializePaddle({
        token: import.meta.env.VITE_PADDLE_TOKEN,
        environment: determineEnv() === 'prod' ? 'production' : 'sandbox',
      });
      paddle?.Checkout.open({
        transactionId,
        settings: {
          allowLogout: false,
          showAddDiscounts: false,
          successUrl: `${window.location.origin}/payment/success`,
          variant: 'one-page',
        },
      });
    }
  } else {
    const data = await response.json();
    return data;
  }
};
